import { FieldState, FormState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { AgentInput } from "@fidget/common/components/form/agentInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { extractNamesFromEmail } from "@fidget/common/utils/extractNamesFromEmail";
import styles from "./inviteAgentRow.css";

export type AgentFormFields = {
  email: FieldState<string>;
  firstName: FieldState<string>;
  lastName: FieldState<string>;
};

interface Props {
  removeAgent: () => void;
  form: FormState<AgentFormFields>;
  errorHintTop?: boolean;
}

@observer
export class InviteAgentRow extends React.Component<Props> {
  styleType: "signup" = "signup";

  handleBlurOnEmailInput = () => {
    const { firstName, lastName, email } = this.props.form.$;
    if (!firstName.value && !!email.value && !email.hasError) {
      const { firstName: extractedFirstName, lastName: extractedLastName } = extractNamesFromEmail(
        email.value
      );
      firstName.onChange(extractedFirstName);
      lastName.onChange(extractedLastName);
    }
  };

  render() {
    const { firstName, lastName, email } = this.props.form.$;
    const { errorHintTop, removeAgent } = this.props;
    return (
      <div className={styles["input-container"]}>
        <div className={styles["email-input"]}>
          <AgentInput
            field={email}
            styleType={this.styleType}
            errorTooltipPosition={errorHintTop ? "top right" : "bottom right"}
            placeholder={intl.formatMessage("settings.advisers.invite.email")}
            autoFocus
            onBlur={this.handleBlurOnEmailInput}
          />
        </div>
        <div className={styles["name-input"]}>
          <AgentInput
            field={firstName}
            styleType={this.styleType}
            placeholder={intl.formatMessage("settings.advisers.invite.firstName")}
          />
        </div>
        <div className={styles["name-input"]}>
          <AgentInput
            field={lastName}
            styleType={this.styleType}
            placeholder={intl.formatMessage("settings.advisers.invite.lastName")}
          />
        </div>
        <button type={"button"} onClick={removeAgent}>
          <i className="icon-close-cross" />
        </button>
      </div>
    );
  }
}
